<app-dropdown-login-request *ngIf="user && !user.id"></app-dropdown-login-request>
<div class="messages d-flex justify-content-center align-items-center" *ngIf="user && user.id && favoriteUpdates">
    <div class="d-flex justify-content-center align-items-center no-content" *ngIf="!favoriteUpdates.length">
        <h5 style="line-height: 43px">暂无内容</h5>
    </div>


    <div class="scroll-bar w-100" *ngIf="favoriteUpdates.length">
        <div *ngFor="let item of favoriteUpdates">
            <ng-container [ngSwitch]="item.actType">
                <div class="message" *ngSwitchCase="1">
                    <div (click)="msgClick(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    <span class="name-color">您收藏的</span>
                                    <span class="main-color film-title"
                                        title="{{item.lidName}}">《{{(item.lidName.length>22)?(item.lidName |
                                        slice:0:21)+'...':item.lidName}}》</span>
                                    <span class="name-color">已更新至 </span>
                                    <span class="main-color">{{item.vidName}}</span>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message" *ngSwitchCase="2">
                    <div (click)="msgClick(item)" class="w-100">
                        <div class="content">
                            <div class="message-content position-relative">
                                <div class="message-body text-light">
                                    <span class="name-color">您收藏的</span>
                                    <span class="main-color film-title"
                                        title="{{item.lidName}}">《{{(item.lidName.length>22)?(item.lidName |
                                        slice:0:21)+'...':item.lidName}}》</span>
                                    <span class="name-color">已更新完 </span>
                                    <span class="main-color">全集</span>
                                </div>
                            </div>
                            <div class="message-footer">
                                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="dropdown-footer d-flex align-items-center">
    <div class="d-flex align-items-center jbutton jbutton-default"
        [ngClass]="{'disabled': !favoriteUpdates.length}" (click)="clearFavoriteUpdates()">
        <span class="iconfont iconshanchu"></span>
        <span>清空</span>
    </div>
    <a [routerLink]="['/user/favorites']"
        class="d-flex align-items-center jbutton jbutton-default ml-auto">
        <span>收藏夹</span>
        <span class="iconfont iconchakangengduo fs-16"></span>
    </a>
</div>